<template>
  <div class="page-content">
    <div style="background-color: rgba(0, 0, 0, 0.1); height: 100vh">
      <div class="loginContainer">
        <div class="loginSso">
          <p class="text-h2 pt-5 pb-5" style="letter-spacing: 3px !important">Welcome to Northvolt</p>
          <p class="text-h5 pt-4 pb-8">Please login to access Hourly Production Logbook</p>
          <v-btn
            prepend-icon="mdi-lock"
            color="#44a27a"
            block
            @click="$emit('login')"
            class="mt-12"
            style="letter-spacing: 3px"
          >
            Continue with SSO
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["login"],
  name: "LoginPage",
  data: () => ({}),
  methods: {},

  components: {},
};
</script>

<style scoped>
h1,
h5,
p {
  color: #fff;
}
.loginSso {
  background-color: rgba(0, 0, 0, 0.4);
  height: 350px;
  padding: 40px;
  text-align: center;
}
.loginContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.page-content {
  background-image: url("./assets/nvbackground.jpg");
  height: 100vh;
  width: 100%;
  background-position: bottom;
  background-size: cover;
  position: absolute;
}

.bgImg {
  width: 100vw;
  height: 100vh;
}
</style>
